var stickyNav = (function () {
  var scTarget = Array.prototype.slice.call(document.querySelectorAll('body'));
  var navBar = Array.prototype.slice.call(document.querySelectorAll('.secondary-nav'));
  // if vertical nav is used it should not go under the sticky nav
  var verticalNavBg = document.querySelector('.vertical-nav .bg-layer');

  function set() {
    window.addEventListener('scroll', function () {
      var bodyBunding = scTarget[0].getBoundingClientRect();
      if (bodyBunding.top <= -60) {
        navBar[0].classList.add('sticky-top');
        // add margin to vertical nav if exist
        if (verticalNavBg != null) {
          verticalNavBg.style.marginTop = 60 + 'px';
        }
      } else {
        navBar[0].classList.remove('sticky-top');
      }
    }, false);
  }

  return {
    set: set
  }
}());

/* Animation functions
 ------------------------------------*/
// check for type of transition
var transitionEvent = whichTransitionEvent();

function textAnimations(parent, animation, type) {

  if (parent.tagName != undefined) {
    var animatedText = Array.prototype.slice.call(parent.querySelectorAll(animation));

    if (type == 'sequencial') {
      var counter = 0;
      deferredPlay();
    } else {
      animatedText.forEach(function (elm) {
        if (!elm.classList.contains('active')) {
          elm.classList.add('active')
        }
      })
    }

    function deferredPlay() {
      if (counter < animatedText.length) {
        var animBlock = animatedText[counter];
        /*        animBlock.addEventListener(transitionEvent, function(){
         counter++;
         deferredPlay();
         });*/
        setTimeout(function () {
          counter++;
          deferredPlay();
        }, 450);
        if (!animatedText[counter].classList.contains('active')) {
          animatedText[counter].classList.add('active');
          // Add click event (redirect page - whole block is clickable */
          animatedText[counter].addEventListener('click', function (e) {
            e.preventDefault();
            var elmClicked = e.target, parentElmClicked = elmClicked.parentElement;
            if (elmClicked.classList.contains('.fade-to-dull')) {
              redirectToUrl(elemClicked);
            } else {
              redirectToUrl(parentElmClicked);
            }
            function redirectToUrl(elm) {
              var tLink = elm.querySelector('.learn-more-link');
              var url = tLink.href;
              window.location.href = url;
            }
          }, false);
        }
        animatedText[counter].addEventListener('mouseover', applyHoverState, false);
        animatedText[counter].addEventListener('mouseout', removeHoverState, false);
      }
    }

    /* hover effect */
    function applyHoverState() {
      this.setAttribute('hovered', 'true');
      this.classList.add('block-link');
      if (window.innerWidth > 1024) {
        this.setAttribute('style', 'border-top:5px solid #1ea2fd; padding-top: 31px;')
      }
      animatedText.forEach(function (item) {
        if (!item.hasAttribute('hovered')) {
          item.style.opacity = .4;
        }
      })
    }

    function removeHoverState() {
      this.classList.remove('block-link');
      animatedText.forEach(function (item) {
        item.removeAttribute('hovered');
        if (window.innerWidth > 1024) {
          item.removeAttribute('style');
        }
      })
    }

  }
}

function isOnViewPort(targetElem, callBackFunc) {
  if (targetElem.tagName != undefined) {
    var docElem = window.document.documentElement;
    var docElemH = docElem['clientHeight'];
    var rowHeight = targetElem.clientHeight;
    var allowedOffview = rowHeight * .3;
    /* 30 percent of will still trigger slide */
    var rowBottom = targetElem.getBoundingClientRect().bottom,
      rowTop = targetElem.getBoundingClientRect().top,
      bottom = Math.ceil((rowBottom / docElemH) * 100),
      top = Math.ceil((rowTop / docElemH) * 100);
    if (isFullyOnView() || isTopMostlyOnView() || isBottomMostlyOnView()) {
      if (!!callBackFunc) {
        callBackFunc();
      }
      return true;
    } else {
      return false;
    }
  }
  // TODO: this fuctions are used also on whats-new.js need to combine.
  function isFullyOnView() {
    if ((bottom < 100 && bottom > -1) && (top < 100 && top > -1)) {
      return true;
    }
  }

  function isTopMostlyOnView() {
    if ((top < 100 && top > -1) && rowBottom - docElemH < allowedOffview) {
      return true;
    }
  }

  function isBottomMostlyOnView() {
    if ((bottom < 100 && bottom > 0) && Math.abs(rowTop) < allowedOffview) {
      return true;
    }
  }
}

function triggerFadeUpAnimation() {
  var animationParents = Array.prototype.slice.call(document.querySelectorAll('.animation-wrapper'));
  animationParents.forEach(function (parent) {
    if (isOnViewPort(parent)) {
      textAnimations(parent, '.fade-up');
    }
  })
}

function triggerOnebyOneAnim() {
  var blockAnimation = Array.prototype.slice.call(document.querySelectorAll('.block-animation'));
  blockAnimation.forEach(function (block) {
    if (isOnViewPort(block)) {
      textAnimations(block, '.fade-to-dull', 'sequencial');
    }
  })
}

function getDocumentHeight() {
  var body = document.body,
    html = document.documentElement;

  var height = Math.max(body.scrollHeight, body.offsetHeight,
    html.clientHeight, html.scrollHeight, html.offsetHeight);

  return height;
}

function backToTop() {
  var toTopBtn = document.querySelector('.back-to-top');
  toTopBtn.addEventListener('click', function () {
    var step = setInterval(function () {
      var currentPos = (typeof window.scrollY !== "number") ? window.pageYOffset : window.scrollY;
      ;

      /* scrolling effect */
      if (currentPos != 0) {
        if (currentPos > 100) {
          window.scroll(0, currentPos - 30);
        } else if (currentPos > 10) {
          window.scroll(0, currentPos - 10);
        } else {
          window.scroll(0, currentPos - 1);
        }

      } else {
        clearInterval(step);
      }

    }, 10);

  }, false);
}

function openBackToTop() {
  var toTopBtn = document.querySelector('.back-to-top');
  var docHeight = getDocumentHeight()

  window.addEventListener('scroll', function () {
    var currentLoc = (typeof window.scrollY !== "number") ? window.pageYOffset : window.scrollY;
    // get current position percentage in relation to whole document
    var currPerc = Math.floor((currentLoc / docHeight) * 100);

    if (currPerc > 80) {
      if (!toTopBtn.classList.contains('open')) {
        toTopBtn.classList.add('open');
      }
    } else {
      if (toTopBtn.classList.contains('open')) {
        toTopBtn.classList.remove('open');
      }
    }

  }, false);
}

/* end of Animation functions
 ------------------------------------*/

/**
 * http://stackoverflow.com/questions/4994201/is-object-empty
 */
// Speed up calls to hasOwnProperty
var hasOwnProperty = Object.prototype.hasOwnProperty;

function isEmpty(obj) {

  // null and undefined are "empty"
  if (obj == null) return true;

  // Assume if it has a length property with a non-zero value
  // that that property is correct.
  if (obj.length > 0)    return false;
  if (obj.length === 0)  return true;

  // If it isn't an object at this point
  // it is empty, but it can't be anything *but* empty
  // Is it empty?  Depends on your application.
  if (typeof obj !== "object") return true;

  // Otherwise, does it have any properties of its own?
  // Note that this doesn't handle
  // toString and valueOf enumeration bugs in IE < 9
  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }

  return true;
}

/* From Modernizr */
function whichTransitionEvent() {
  var t;
  var el = document.createElement('fakeelement');
  var transitions = {
    'transition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'MozTransition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd'
  }

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

// Get IE or Edge browser version

document.addEventListener('DOMContentLoaded', function () {
  var version = detectIE();

  if (version !== false) {
    document.querySelector('body').classList.add('ie');
  }
});


/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */

function detectIE() {
  var ua = window.navigator.userAgent;


  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}
